import React, { useEffect } from 'react';
import { Link, Outlet, useParams } from 'react-router-dom';
import Icon from '../../component/Icon';
import * as actionCreators from '../../store/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import { ShowEmptyView } from '../../component/UI/Loader/Loader';

function Menu() {
  console.log('Menu.js');
  const params = useParams();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.product.frontend);
  useEffect(() => {
    if (state.productList) return;
    dispatch(actionCreators.getMenuCategories());
    dispatch(actionCreators.getAllProducts());
    console.log(state.productList)
  }, []);
  return (
    <div className='grid grid-cols-12'>
      {/* MENU TOP  */}
      <div className='col-start-1 col-end-13 relative py-8 pt-0'>
        <img
          src='/images/menuHero.png'
          style={{ filter: 'brightness(80%)' }}
          alt='menu'
          className='block'
        />
        <div className='absolute text-white top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]'>
          <h2 className='font-SourceSerif text-7xl text-center'>
            Welcome To Start Menu
          </h2>
          <p className='text-xl text-center font-SansitaSwashed'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
            vulputate libero et velit interdum, ac aliquet odio mattis. Class
            aptent taciti sociosqu ad litora torquent per conubia no
          </p>
        </div>
      </div>

      {/* CATEGORY */}
      <div className='col-start-2 col-end-12 py-8 pb-2'>
        {/* LEFT */}
        <div className='flex gap-4 flex-wrap items-center text-primary'>
          <Link to='' className='flex items-center gap-4'>
            <Icon name='ham' className='w-[1.5rem] h-[1.5rem] fill-primary' />
            <p
              className={`text-lg ${
                !params.id && 'border-b-2'
              } text-greyPrimary font-SourceSerif`}
            >
              All
            </p>
          </Link>
          {!state.menuCategories && <ShowEmptyView text='Please wait...' />}
          {state.menuCategories && state.menuCategories.length === 0 && (
            <ShowEmptyView text='No categories...' />
          )}

          {state.menuCategories &&
            state.menuCategories.map((el, id) => {
              return (
                <Link
                  to={el.id}
                  key={id}
                  className={`text-lg text-greyPrimary ${
                    params.id === el.id ? 'border-b-2' : null
                  } font-SourceSerif capitalize`}
                >
                  {el.title}
                </Link>
              );
            })}

          <form className=' ml-auto rounded-md flex'>
            <input
              type='text'
              className=' border border-r-transparent border-primary p-2 rounded-l-md placeholder:font-Poppins focus:outline-none'
              placeholder='Birthday cakes'
            />
            <button
              type='submit'
              className='font-Poppins border-primary font-semibold p-2 border rounded-r-md '
            >
              Search
            </button>
          </form>
        </div>
        {/* RIGHT */}
      </div>

      {/* CATEGORY PRODUCTS */}
      <div className='col-start-2 col-end-12 py-4'>
        <Outlet />
      </div>

      {/* SALE */}
    </div>
  );
}

export default Menu;
